import { format } from "date-fns";
import { now } from "mobx-utils";

export function formatDeadline(date: Date): string {
  const currYear = new Date(now()).getFullYear();
  const passedYear = date.getFullYear();
  const deadlineInCurrentYear = passedYear === currYear;
  return format(date, deadlineInCurrentYear ? "d. MMM" : "d. MMM yyyy");
}
